export const easeIn = (t: number, alpha: number): number => Math.pow(t, alpha);
